import { useMemo } from "react"

export default function usePreferredLanguages() {
  return useMemo(() => ["ru", "en"], [])
}
